import { useState, useEffect } from 'react';
import Search from 'carbon-react/esm/components/search';
import filtersearchProps from '../types/filtersearch.types';

const SearchDeclarations = ({ onSearch, value }: filtersearchProps) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (ev: { target: { value: string } }) => {
    const newValue = ev.target.value;
    setLocalValue(newValue);
  };

  const handleDirectSearch = () => {
    onSearch(localValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleDirectSearch();
      e.preventDefault();
    }
  };

  return (
    <Search
      label="Recherche"
      aria-label="Siret, Siren, Salarié, Raison sociale..."
      triggerOnClear
      onChange={handleChange}
      onClick={ev => {
        const valueToUse = ev.target.value;
        if (valueToUse) {
          onSearch(valueToUse);
        } else {
          onSearch('');
        }
      }}
      value={localValue}
      onKeyDown={handleKeyDown}
      onBlur={() => {
        if (localValue === '') {
          onSearch('');
        }
      }}
    />
  );
};

export default SearchDeclarations;
